<template>
  <div class="home p-b-footer">
    <transition name="fade">
    <div class="" v-if="statistics">
      <div class="head-max">
        <swiper :list="filSwiper(banner)" style="width:65%;margin:0 auto;" class="head-swiper" :dots-position="'center'" auto :interval="5000" :duration="1000"></swiper>
      </div>
      <div class="wapper">
        <div class="information-max" v-if="statistics">
          <div class="">
            <p class="font-bold">{{statistics.finish_num}}</p>
            <p class="tit"><i class="one"></i>总成交</p>
          </div>
          <div class="">
            <p class="font-bold">{{filPrice(statistics.follow)}}<i v-show="statistics.follow > 10000">万</i></p>
            <p class="tit"><i class="two"></i>关注支持</p>
          </div>
          <div class="">
            <p class="font-bold">{{statistics.product_num}}</p>
            <p class="tit"><i class="three"></i>车型</p>
          </div>
        </div>

        <div class="hot-rv">
          <h3>火热预定 <a @click="goList(0)">所有预定车型</a></h3>
          <div @click="openProductDetail(item)" class="product-item" v-for="(item, index) in products" :key="index">
            <div class="banner">
              <img :src="item.logo" alt="">
              <span class="reserve">{{item.tag}}</span>
              <p class="bottom">
                <span class="time">上市时间:{{filDate(item.publish_at)}}</span>
                <span class="num">已抢先预定<i>{{item.sold_num}}</i>辆</span>
              </p>
            </div>
            <div class="title">
              {{item.title}}
            </div>
          </div>
        </div>
        <div class="hot-rv" v-if="special && special.length > 0">
          <h3>特价秒杀<a @click="goList(1)">所有特价车型</a></h3>
          <div @click="openProductDetail(item)" class="product-item" v-for="(item, index) in special" :key="index">
            <div class="banner">
              <img :src="item.logo" alt="">
              <span class="reserve">{{item.tag}}</span>
              <p class="bottom">
                <span class="price">特价:<b>{{filPrice(item.special_price)}}</b><i v-show="item.special_price > 10000">万</i></span>
                <span class="num">仅剩<i>{{item.stock_surplus}}</i>辆</span>
              </p>
            </div>
            <div class="title">
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
    <footers :active="1"></footers>
  </div>
</template>

<script>
import HomeService from '../service/HomeService'
import Footers from './common/footer.vue'
import { Swiper } from 'vux/src/components/swiper'
import wx from 'weixin-js-sdk'
import api from '@/api'
import axios from '@/axios'

export default {
  name: 'Home',
  components: {
    Swiper,
    Footers
  },
  data: () => ({
    banner: null,
    products: null,
    special: null,
    statistics: null,
    wechat_share: null
  }),
  methods: {
    init () {
      this.getList()
    },
    async getList () {
      // todo loading
      const res = await HomeService.getHomeSetting()
      if (res) {
        const { banner, products, special, statistics, wechat_share } = res
        this.banner = banner
        this.products = products
        this.special = special
        this.statistics = statistics
        this.wechat_share = wechat_share
        this.initWechat()
      }
    },
    openProductDetail (item = {}) {
      const { id } = item
      this.$router.push({ name: 'ProductDetail', params: { id } })
    },
    filSwiper (list) {
      const arr = []
      if (list) {
        list.forEach(item => {
          arr.push({ img: item.logo, url: item.link })
        })
      }
      return arr
    },
    filPrice (val) {
      if (val > 10000) {
        return (val / 10000).toFixed(2)
      } else {
        return val
      }
    },
    goList (ind) {
      this.$router.push({ name: 'ProductList', query: { type: ind } })
    },
    filDate (val) {
      if (val) {
        const date = val.split(' ')[0].split('-')
        return date[0] + '年' + date[1] + '月' + date[2] + '日'
      }
    },
    initWechat () {
      var url = window.sessionStorage.getItem('initUrl') || window.location.href
      var targetUrl = window.location.href
      axios.post(api.account.wxcode, { url: url }).then(response => {
        if (response.data.code === 200) {
          wx.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: response.data.data.timestamp,
            nonceStr: response.data.data.noncestr,
            signature: response.data.data.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          })
          wx.ready(() => {
            // 发送给朋友
            wx.onMenuShareAppMessage({
              title: this.wechat_share.appMessage.title,
              desc: this.wechat_share.appMessage.desc,
              link: targetUrl,
              imgUrl: this.wechat_share.appMessage.imgUrl,
              success: function (res) {
              },
              cancel: function (res) {
              }
            })
            // 朋友圈
            wx.onMenuShareTimeline({
              title: this.wechat_share.appMessage.title,
              link: targetUrl,
              imgUrl: this.wechat_share.appMessage.imgUrl,
              success: function (res) {
              },
              cancel: function (res) {
              }
            })
          })
          wx.error(function (res) {
          })
        }
      })
    }
  },
  created () {
    this.init()
  }
}
</script>
